import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-validation-icon',
    templateUrl: './validation-icon.component.html',
    standalone: false
})
export class ValidationIconComponent {

  @Input() submitted: boolean | null = false;
  @Input() isInvalid: boolean | null = false;
  @Input() isFocused = false;
  @Input() noErrorOnFocus = false;
  @Input() isSmall = true;
  @Input() errorAsText = false;
}